import React from "react";
import { StaticQuery, graphql } from "gatsby";

import { convertToUrlPath } from "../../helpers";

import Client from "../molecules/client";

import Button from "../atoms/button";
import DictionaryEntry from "../atoms/dictionary-entry";
import "../../scss/organisms/_our-clients.scss";

class OurClients extends React.Component {
  render() {
    return (
      <section className="section our-clients pt-6 pb-7">
        <div className="container">
          <h2 className="h4 mb-5">
            <DictionaryEntry
              dictionaryEdges={this.props.dictionaryEdges}
              dictionaryKey="home-page.our-clients.title"
              language={this.props.language}
            />
          </h2>
          <div className="client-list">
            <StaticQuery
              query={graphql`
                query ourClients {
                  allContentfulClient(
                    sort: { fields: [title], order: ASC }
                    filter: { node_locale: { eq: "en-EU" } }
                  ) {
                    edges {
                      node {
                        title
                        media {
                          title
                          fluid(maxWidth: 200) {
                            ...GatsbyContentfulFluid_withWebp
                          }
                          file {
                            url
                          }
                        }
                        referenceCase {
                          title
                          slug
                        }
                      }
                    }
                  }
                }
              `}
              render={data => {
                const clients = data.allContentfulClient.edges.map(
                  (client, index) => {
                    const casePath =
                      client.node.referenceCase &&
                      (client.node.referenceCase.slug &&
                      client.node.referenceCase.slug.length
                        ? client.node.referenceCase.slug
                        : convertToUrlPath(client.node.referenceCase.title));

                    return (
                      <Client
                        key={index}
                        media={{
                          fluid: client.node.media.fluid,
                          extension: client.node.media.file.url
                            .split(".")
                            .slice(-1)[0],
                          src: client.node.media.file.url,
                          alt: client.node.media.title,
                        }}
                        to={casePath ? "/cases/" + casePath : undefined}
                      />
                    );
                  }
                );
                return clients;
              }}
            />
          </div>
          <div className="d-flex">
            <Button className="mx-auto mt-5" type="secondary" to="cases">
              <DictionaryEntry
                dictionaryEdges={this.props.dictionaryEdges}
                dictionaryKey="home-page.our-clients.cta"
                language={this.props.language}
              />
            </Button>
          </div>
        </div>
      </section>
    );
  }
}

export default OurClients;
